import type { HTMLAttributes } from "react";
import { cva } from "class-variance-authority";
import { cn } from "./cn";

const chip = cva(
  "inline-flex h-6 max-w-full items-center gap-1.5 rounded-chip px-2 text-xs font-semibold leading-none whitespace-nowrap [&_svg]:size-3.5 [&_svg]:shrink-0",
  {
    variants: {
      tone: {
        neutral: "bg-tone-gray text-tone-gray-ink",
        brand: "bg-tone-brand text-tone-brand-ink",
        accent: "bg-tone-accent text-tone-accent-ink",
        cream: "bg-tone-cream text-tone-cream-ink",
        ok: "bg-tone-mint text-tone-mint-ink",
        bad: "bg-tone-red text-tone-red-ink",
        outline: "bg-surface text-ink-soft ring-1 ring-inset ring-line-strong",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export type ChipTone = "neutral" | "brand" | "accent" | "cream" | "ok" | "bad" | "outline";

export type ChipProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: ChipTone;
};

/** A near-square label for facts and filters: location, salary, a skill. For a lifecycle state use `StatusBadge`. */
export function Chip({ tone = "neutral", className, children, ...rest }: ChipProps) {
  return (
    <span className={cn(chip({ tone }), className)} {...rest}>
      <span className="truncate">{children}</span>
    </span>
  );
}
